/**
 * The app version is intended to serve two purposes:
 * 1) Makes comparison easy
 * 2) Unique across builds
 *
 * The format is of the following:
 * <iso-8601-build-time>+<build-sha>
 * 2025-08-24T10:15:00Z+21a2f5acdc0f742477ae5555dbaeaad274de6fdc
 *
 * Build time is in seconds and UTC
 */
export function compareVersions(a: string, b: string) {
  const [aVersion] = a.split('+')
  const [bVersion] = b.split('+')

  const aNorm = normalizeVersion(aVersion)
  const bNorm = normalizeVersion(bVersion)

  if (aNorm < bNorm) return -1
  else if (aNorm > bNorm) return 1
  else return 0
}

function normalizeVersion(v: string) {
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return `${v}T00:00:00Z`
  if (/\.\d+Z$/.test(v))
    throw new Error('Fractional seconds are not supported in app version timestamps')
  return v
}

export function buildAppVersion(buildTime: string | undefined, buildSha: string | undefined) {
  if (!buildTime || !buildSha) return undefined
  if (/\.\d+Z$/.test(buildTime))
    throw new Error('Fractional seconds are not supported in app version timestamps')
  return `${buildTime}+${buildSha}`
}
